import { Avatar, AvatarFallback, AvatarImage, Card, CardContent } from "@devhop/ui";
import { Calendar, User } from "lucide-react";
import type { ProjectDetail } from "@/modules/management/project/domain/types";
import { getInitials } from "@/shared/lib/utils";
import { resolveImageSrc } from "@/shared/ui/AppImage";

function formatDate(s: string) {
  try {
    return new Date(s).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  } catch {
    return s;
  }
}

export function ProjectDetailTimelineTab({
  project,
}: {
  project: ProjectDetail;
}) {
  const phases = project.phases ?? [];

  if (phases.length === 0) {
    return (
      <Card>
        <CardContent className="py-8 text-center text-muted-foreground text-sm">
          ບໍ່ມີຂັ້ນຕອນ ຫຼື ຈຸດໝາຍ (ສະແດງຈາກວຽກຍ່ອຍທີ່ມີວັນກຳນົດ)
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardContent className="pt-4">
        <ul className="space-y-3">
          {phases.map((phase, index) => (
            <li
              key={phase.id}
              className="flex items-center gap-4 rounded-lg border p-3"
            >
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-muted font-medium text-muted-foreground text-sm">
                {index + 1}
              </span>
              <div className="min-w-0 flex-1">
                <p className="font-medium">{phase.name}</p>
                {phase.dueDate && (
                  <p className="mt-0.5 flex items-center gap-1 text-muted-foreground text-sm">
                    <Calendar className="h-3.5 w-3.5" />
                    {formatDate(phase.dueDate)}
                  </p>
                )}
                {phase.assigneeId && phase.assigneeName && (
                  <div className="mt-2 flex items-center gap-2">
                    <Avatar className="h-7 w-7 shrink-0">
                      <AvatarImage
                        src={
                          resolveImageSrc(phase.assigneeImage ?? undefined) ??
                          undefined
                        }
                        alt={phase.assigneeName}
                      />
                      <AvatarFallback className="text-xs">
                        {getInitials(phase.assigneeName)}
                      </AvatarFallback>
                    </Avatar>
                    <span className="text-muted-foreground text-sm">
                      {phase.assigneeName}
                    </span>
                  </div>
                )}
                {phase.assigneeId && !phase.assigneeName && (
                  <p className="mt-1 flex items-center gap-1 text-muted-foreground text-xs">
                    <User className="h-3.5 w-3.5" />
                    ມີຜູ້ຮັບຜິດຊອບ
                  </p>
                )}
              </div>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
}
